export const formatRows = (listaItems) => 
    listaItems.map((item) => ({
      id: item.id,
      lp_descripcion: item.lp_descripcion,
      lp_tipo_precio: item.lp_tipo_precio,
      lp_porc: item.lp_porc,
    }));
  